module.exports = __webpack_public_path__ + "img/logo.39aa0735.svg";